/** @jsx jsx */
import { gql } from '@apollo/client';
import Gallery from '@browniebroke/gatsby-image-gallery';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import React from 'react';
import { Button, jsx } from 'theme-ui';
import Section from '../Section/Section';

const previewImagesAmount = 8;
export default function BrandGallery({ brand, ...rest }) {
  const [visibleCount, setVisibleCount] = React.useState(previewImagesAmount);
  if (!hasContent(brand)) return null;
  const images = brand.galleryImages.map((image, index) => ({
    ...image,
    full: { sizes: '100vw', ...image?.full },
    thumb: index < visibleCount && { sizes: '220px', ...image?.thumb },
  }));
  const totalCount = brand.galleryImages?.length;
  const isExpanded = totalCount === visibleCount;
  return (
    <Section title={<Trans>Gallery</Trans>} {...rest}>
      <Gallery images={images} />
      {totalCount > previewImagesAmount && (
        <Button
          variant="outline"
          sx={{ marginY: 2 }}
          onClick={() =>
            setVisibleCount(isExpanded ? previewImagesAmount : totalCount)
          }
        >
          {isExpanded ? 'Show less' : `Show ${totalCount - visibleCount} more`}
        </Button>
      )}
    </Section>
  );
}
BrandGallery.hasContent = hasContent;
function hasContent(brand) {
  if (!brand) return false;
  if (!brand.galleryImages?.length) return false;
  if (brand.LWFConfiguration?.hasPhotobook) return true;
  if (brand?.__typeName !== 'Exhibitor') return true;
  return false;
}

export const fragment = graphql`
  fragment BrandGallery on Bottlebooks_AbstractBrand {
    galleryImages {
      title
      caption: description # Gallery wants the description as caption.
      thumb: fixed(width: 240, height: 240, gravity: FACES_AUTO) {
        src
        srcSet
        width
        height
        aspectRatio
      }
      full: fluid(maxWidth: 1920, background: "#fff") {
        src
        srcSet
        width
        height
        aspectRatio
      }
    }
  }
`;

export const BrandGalleryFragment = gql`
  fragment BrandGallery on AbstractBrand {
    galleryImages {
      title
      caption: description # Gallery wants the description as caption.
      thumb: thumbnail(width: 240, height: 240) {
        src
        srcSet
        width
        height
        aspectRatio
      }
      full: fluid(maxWidth: 1920) {
        src
        srcSet
        width
        height
        aspectRatio
      }
    }
  }
`;
